import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isAuthed } from "./utils/auth";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Learning from "./pages/Learning";
import Activities from "./pages/Activities";
import Benefit from "./pages/Benefit";
import AddLearning from "./pages/AddLearning";
import AddBenefit from "./pages/AddBenefit";
import AddActivity from "./pages/AddActivity";
import AddQuiz from "./pages/AddQuiz";
import SingleQuiz from "./pages/SingleQuiz";
import Login from "./pages/Login";
import Advocacy from "./pages/Advocacy";
import UserActivitiesProof from "./pages/UserActivitiesProof";
import RewardUser from "./pages/RewardUser";
import Reward from "./pages/Reward";
import WithdrawalRequests from "./pages/WithdrawalRequests";
import QuizResults from "./pages/QuizResults";
import Notification from "./pages/Notification";
import Rewards from "./pages/Rewards";
import Users from "./pages/Users";

// Client-side guard for admin pages. The server enforces admin auth on every
// endpoint; this keeps unauthenticated users out of the UI shell.
const RequireAdmin = ({ children }) =>
  isAuthed() ? children : <Navigate to="/" replace />;

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/home" element={<RequireAdmin><Home /></RequireAdmin>} />
          <Route path="/users" element={<RequireAdmin><Users /></RequireAdmin>} />
          <Route path="/notification" element={<RequireAdmin><Notification /></RequireAdmin>} />
          <Route path="/quiz" element={<RequireAdmin><Quiz /></RequireAdmin>} />
          <Route path="/quiz/add-quiz" element={<RequireAdmin><AddQuiz /></RequireAdmin>} />
          <Route path="/quiz/:id" element={<RequireAdmin><SingleQuiz /></RequireAdmin>} />
          <Route path="/quiz/quiz-results" element={<RequireAdmin><QuizResults /></RequireAdmin>} />
          <Route path="/learning" element={<RequireAdmin><Learning /></RequireAdmin>} />
          <Route path="/learning/add-learning" element={<RequireAdmin><AddLearning /></RequireAdmin>} />
          <Route path="/activities" element={<RequireAdmin><Activities /></RequireAdmin>} />
          <Route path="/activities/add-activities" element={<RequireAdmin><AddActivity /></RequireAdmin>} />
          <Route
            path="/activities/user-activities-proof"
            element={<RequireAdmin><UserActivitiesProof /></RequireAdmin>}
          />
          <Route path="/benefit" element={<RequireAdmin><Benefit /></RequireAdmin>} />
          <Route path="/benefit/add-benefit" element={<RequireAdmin><AddBenefit /></RequireAdmin>} />
          <Route path="/benefit/reward-user" element={<RequireAdmin><RewardUser /></RequireAdmin>} />
          <Route path="/benefit/rewards" element={<RequireAdmin><Rewards /></RequireAdmin>} />
          <Route path="/benefit/withdrawal-requests" element={<RequireAdmin><WithdrawalRequests /></RequireAdmin>} />
          <Route path="/advocacy" element={<RequireAdmin><Advocacy /></RequireAdmin>} />
          <Route path="/reward/:user" element={<RequireAdmin><Reward /></RequireAdmin>} />
          <Route exact path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
